import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=c4be285c&scoped=true&"
import script from "./PhotoGallery.vue?vue&type=script&lang=ts&"
export * from "./PhotoGallery.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=c4be285c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4be285c",
  null
  
)

export default component.exports